//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EmoticonSadOutline from 'vue-material-design-icons/EmoticonSadOutline'
import ProgressIndicator from '@/components/Shared/ProgressIndicator'
import Button from '@/components/Shared/Button'
export default {
  components: {
    EmoticonSadOutline,
    ProgressIndicator,
    Button,
  },
  props: {
    actualOpportunities: {
      type: Array,
      default: () => [],
    },
    opportunities: {
      type: Array,
      default: () => [],
    },
    opportunityDetail: {
      type: Function,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: true,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  methods: {
    goToExperiences() {
      this.$router.push('/experiencias')
    },
  },
}
